<div class="input-group">
    <span class="input-group-text ps-2 pe-1 bg-transparent border-end-0 border-success">
        <span class="badge fw-semibold text-secondary bg-secondary-subtle text-uppercase">{{ currencySymbol }}</span>
    </span>
    <input [id]="inputId" type="text"
        class="form-control py-2 focus-ring border-success fw-bold focus-ring-success border-start-0"
        [class.bg-light]="readonly" [class.text-muted]="readonly" [placeholder]="placeholder" mask="separator.2"
        thousandSeparator="," [(ngModel)]="value" (ngModelChange)="onModelChange($event)" [disabled]="disabled"
        [readonly]="readonly" (blur)="onBlur()" [class.is-invalid]="showMinError || showMaxError" />
</div>

@if (showMinError || showMaxError) {
<div class="text-danger small mt-1">
    Rango válido: {{ (min ?? 0) | number:'1.2-2' }} - {{ (max ?? 0) | number:'1.2-2' }}
</div>
}